import React from 'react';

export default function ErrorState({ message = 'Não foi possível carregar' }) {
  return <div className="admin-error">{message}</div>;
}
